import React, { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui-compat';
import { NullableMeasure } from '@e2m-customer-portal/shared';

const useStyles = makeStyles()((theme) => ({
  grid: {
    backgroundColor: theme.palette.grey[100],
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(1, 2),
    margin: 0,
    display: 'flex',
  },
  item: {},
  line: {
    backgroundColor: theme.palette.grey[300],
    width: '1px',
    height: '100%',
    margin: theme.spacing(0, 1),
  },
  label: {
    color: theme.palette.grey[400],
    fontSize: '12px',
    fontWeight: 400,
    margin: 0,
  },
  value: {
    fontSize: '14px',
    fontWeight: 400,
    margin: 0,
  },
}));

export interface ForecastTemplateInfoProps {
  lowerLimit: NullableMeasure;
  upperLimit: NullableMeasure;
  auxiliary: NullableMeasure;
  unit?: string;
}

export function ForecastTemplateInfo({
  lowerLimit,
  upperLimit,
  auxiliary,
  unit,
}: Readonly<ForecastTemplateInfoProps>): ReactElement<ForecastTemplateInfoProps> {
  const { classes } = useStyles();
  const [t] = useTranslation();

  return (
    <dl className={classes.grid}>
      <div className={classes.item}>
        <dt className={classes.label}>{t('SHARED_PRODUCT_MAXIMUM')}</dt>
        <dd className={classes.value}>{t('SHARED_MEASURE', { value: upperLimit, unit: unit ?? 'kW' })}</dd>
      </div>

      <div className={classes.item}>
        <div className={classes.line} />
      </div>

      <div className={classes.item}>
        <dt className={classes.label}>{t('SHARED_PRODUCT_MINIMUM')}</dt>
        <dd className={classes.value}>{t('SHARED_MEASURE', { value: lowerLimit, unit: unit ?? 'kW' })}</dd>
      </div>

      <div className={classes.item}>
        <div className={classes.line} />
      </div>

      <div className={classes.item}>
        <dt className={classes.label}>{t('SHARED_PRODUCT_CONSUMPTION')}</dt>
        <dd className={classes.value}>{t('SHARED_MEASURE', { value: auxiliary, unit: unit ?? 'kW' })}</dd>
      </div>
    </dl>
  );
}
